import React from 'react'
import { UserOne, UserTwo, UserThree } from 'src/assets'
import { HelpHeader, HelpBody, HelpWrapper } from './helpStyle'
import HelpAccordion from 'src/components/Global/Accordion/HelpAccordion'

const Help = () => {
  return (
    <HelpWrapper>
      <HelpHeader>
        <div className="text_wrapper">
          <div className="text_img_wrapper">
            <h1>Hello</h1>
            {/* <img src={UserOne} alt="" />
            <img src={UserTwo} alt="" />
            <img src={UserThree} alt="" /> */}
          </div>
          <p>
            We are available Mondays to Fridays from 9am to 4:30pm via these
            channels. Emails are 24hrs
          </p>
        </div>
      </HelpHeader>
      <HelpBody>
        <h1 className="title">Our Channels</h1>
        <div className="help_accordion">
          <HelpAccordion />
        </div>
      </HelpBody>
    </HelpWrapper>
  )
}

export default Help
